function stubTrue() {
    return true;
}

export { stubTrue };
